/**
 * 多版本菜单 B6（老扫码站 U-B6-3）：预览码「还在预览」还是「已结束」（owner D88）。横幅只问这里。
 *
 * 照搬 kiosk `src/shared/review/previewMenuStatus.ts`（已审）的判据：
 * 后端对停止分享 / 已发布 / 已归档 / 已删除 / 不认的码一律回正式菜单，`resolvedMenu.preview` 都不是 true；
 * 判据不只看 preview —— **preview === true 且 kind === 'derived' 且 menuId 是非空串** 才算还在预览（预览只给草稿，草稿一定是派生菜单），
 * 同一个码前后答复的 menuId 也必须一致。「已结束」不是终态：每份答复都重判（缓存抖动 / 后端短暂回非预览时自愈）。
 *
 * 信号来源：响应拦截器（`utils/request/requestMixin.js`）—— 带着 `X-Preview-Menu` 发出去的请求、成功回包里带 `resolvedMenu` 对象时报这里。
 * 请求失败（网络 / success:false）不报：断网不等于预览结束。
 *
 * 「已结束」只改横幅那句话（显示的已经是主菜单）。**拦单不跟着解除**：地址里还带着形状合法的码，下单请求照样带头、
 * 后端 D80 照样拒（owner D98②「地址里有形状合法的码就本地拦单」）—— 见 changelog 偏离说明。
 *
 * 只在内存（Vue.observable），按码记，零存储；整页重载后第一份答复再判一次。
 */
import Vue from 'vue'

const state = Vue.observable({ endedTokens: [] })
/** 每个码第一次被确认时对应的草稿 menuId（不需要响应式） */
const confirmedMenuId = new Map()

/** 后端答复（get-menu / get-product-list 的 `resolvedMenu`）是不是「凭预览码看的那份草稿」 */
export function isPreviewMenuAnswer(resolved) {
  if (!resolved || typeof resolved !== 'object' || Array.isArray(resolved)) return false
  return resolved.preview === true && resolved.kind === 'derived' && typeof resolved.menuId === 'string' && resolved.menuId !== ''
}

/**
 * 报一份「带着预览码 token 发出去的请求」的答复，并按它重判这个码：
 * 是这个码的那份草稿 → 回到 / 保持预览中，返回 true；不是 → 记成已结束，返回 false。
 */
export function notePreviewMenuAnswer(token, resolved) {
  const isDraft = isPreviewMenuAnswer(resolved)
  const first = confirmedMenuId.get(token)
  if (!isDraft || (first !== undefined && first !== resolved.menuId)) {
    if (!state.endedTokens.includes(token)) state.endedTokens = [...state.endedTokens, token]
    return false
  }
  if (first === undefined) confirmedMenuId.set(token, resolved.menuId)
  if (state.endedTokens.includes(token)) state.endedTokens = state.endedTokens.filter(t => t !== token)
  return true
}

/**
 * 这个码此刻的状态。没有码 → 'none'；有码 → 'active'（包括还没听到答复）/ 'ended'。
 * @param {String|null} token `currentPreviewMenuToken()` 的结果
 * @returns {'none'|'active'|'ended'}
 */
export function previewMenuStatus(token) {
  if (!token) return 'none'
  return state.endedTokens.includes(token) ? 'ended' : 'active'
}

/** 仅测试：清空全部状态 */
export function __resetPreviewMenuStatusForTest() {
  state.endedTokens = []
  confirmedMenuId.clear()
}
